@if (isMulti()) {
  <elcia-multi-dropdown [control]="control()"
                        [items]="items()"
                        [label]="label() ?? ('entity.customers' | translate)"
                        [textField]="'fullName'"/>
} @else {
  <elcia-dropdown (selectionChange)="onSelectionChange($event)"
                  [control]="control()"
                  [items]="items()"
                  [label]="label() ?? ('entity.customer' | translate)"
                  [textField]="'fullName'">
    <ng-template #item let-item>
      <div class="flex items-center gap-2">
        <elcia-icon [iconType]="item.type === PartyType.Company ? 'building' : 'user'" [iconSize]="'sm'"/>
        <span>{{ item.fullName }}</span>
      </div>
    </ng-template>
  </elcia-dropdown>
}
